/* eslint-disable */
import { Button } from '@/Components/ui/button';
import {
	FileText, Download
} from 'lucide-react';

const DocumentsImagesSection = (props) => {
	const { documents, handlePreview, downloadButton = [] } = props;
	const formatDate = (dateString) => {
		return dateString;
	};
	return (
		<div className='w-full relative border border-slate-300 rounded-lg'>
			<div className='w-full'>
				{downloadButton?.length > 0 && (
					<div className='flex justify-end gap-2 items-center m-2'>
						{downloadButton?.map((button, index) => (
							button?.noButton ? (
								<div key={index} className='flex flex-1'>
									<span className={`text-sm text-gray-500 ${button?.style}`}>{button?.infoText}</span>
								</div>
							) : (
								<button key={index} onClick={() => window.open(button?.url, '_blank')}
									className={`
										flex items-center justify-center 
										px-4 py-2 
										gap-2
										text-sm font-medium 
										rounded-md border
										transition-colors duration-200
                                        text-nowrap
										flex-1
										${button?.style}
										${button?.disabled ? 'opacity-50 cursor-not-allowed' : ''}
									`}
								>
									{button?.icon}
									{button?.name}
								</button>
							)))}
					</div>
				)}
				<div className='p-4'>
					{documents?.length > 0 ? (
						<div className='space-y-4'>
							{(documents || [])?.map((doc, idx) => (
								<div
									key={doc.id}
									className='bg-gray-50 cursor-pointer rounded-lg border border-gray-200 p-4 hover:shadow-sm transition-shadow'
									onClick={() => handlePreview({ ...doc, idx }, documents)}
								>
									<div className='flex items-center gap-4'>
										<div className='w-10 h-10 bg-red-100 rounded-lg flex items-center justify-center'>
											<FileText className='w-5 h-5 text-red-600' />
										</div>

										<div className='flex-1'>
											<div className='flex items-center gap-2 mb-1'>
												<h3 className='font-medium text-gray-900'>{doc?.name || 'Unnamed Document'}</h3>
												{doc?.type && (
													<span className='px-2 py-0.5 bg-blue-50 text-blue-600 text-[10px] font-bold rounded border border-blue-100 uppercase tracking-tight'>
														{doc.type}
													</span>
												)}
											</div>
											<p className='text-sm text-gray-500'>
												Generated on
												{' '}
												{formatDate(doc?.uploadedDate)}
											</p>
										</div>

										<div className='flex items-center gap-2'>
											<button
												onClick={(e) => {
													e.stopPropagation();
													window.open(doc?.url, '_blank');
												}}
												className='p-2 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-lg transition-colors'
												title='Download'
											>
												<Download className='w-5 h-5' />
											</button>
										</div>
									</div>
								</div>
							))}
						</div>
					) : (
						<div className='text-center'> Document Is Not Available </div>
					)}
				</div>
			</div>
		</div >
	);
};

export default DocumentsImagesSection;
